<template>
  <!-- TODO Adaptive styles -->
  <div class="app-main2">
    <SignInModal />
    <SignUpModal />

    <header>
      <div class="container">
        <div class="d-logo logo-wrap">
          <div class="logo">
            <div class="dots">
              <div></div>
              <div></div>
              <div></div>
            </div>
            <img class="title" src="./../assets/images/logo.svg" alt="logo" />
          </div>
        </div>
        <ul>
          <li>
            <router-link class="link" to="/">Home</router-link>
          </li>
          <li>
            <router-link class="link" to="/about">About</router-link>
          </li>
          <li>
            <router-link class="link" to="/how-it-works"
              >How it works</router-link
            >
          </li>
          <li>
            <div class="y-btn link" @click="openSignUp">Join</div>
          </li>
        </ul>
      </div>
    </header>
    <section class="main container">
      <div class="wrap">
        <main>
          <h1>
            Lorem Ipsum is simply text of printing
          </h1>
          <p>
            Lorem Ipsum has been the industry's standard dummy text ever when an
            unknown printer took a type and scrambled it to make
          </p>
          <div class="install-btn">Install App</div>
        </main>
        <GirlIllustration class="illustration" />
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { ModalEvents } from 'app/utils/events';
import SignInModal from 'app/components/modals/SingInModal.vue';
import SignUpModal from 'app/components/modals/SignUpModal.vue';
import GirlIllustration from 'app/components/landing/GirlIllustration.vue';

export default {
  name: 'Main2',
  components: {
    SignInModal,
    SignUpModal,
    GirlIllustration,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters([]),
  },

  mounted() {},
  methods: {
    openSignIn() {
      ModalEvents.emit('signin:open');
    },
    openSignUp() {
      ModalEvents.emit('signup:open');
    },
  },
};
</script>

<style lang="scss" scoped>
.app-main2 {
  header {
    padding-top: 60px;
    .container {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    ul {
      display: flex;
      li {
        .link {
          font-size: 14px;
          display: inline-block;
          color: black;
          padding: 8px 15px;

          &.y-btn {
            color: white;
            padding: 8px 35px;
            border-radius: 50px;
            margin-left: 15px;
          }
        }
      }
    }
  }

  section.main {
    padding-top: 40px;
    .wrap {
      display: flex;
      position: relative;
      height: 80vh;
    }

    main {
      width: 45%;
      padding-left: 30px;
      box-sizing: border-box;
      h1 {
        color: #13426a;
        font-size: 58px;
        line-height: 80px;
        font-weight: bold;
        margin-bottom: 20px;
        margin-top: 100px;
      }

      p {
        color: #9a9a9a;
        font-size: 14px;
        line-height: 30px;
        max-width: 340px;
        margin: 0;
        margin-bottom: 25px;
      }

      .install-btn{
        background: #168fff;
        color: white;
        font-size: 14px;
        display: inline-block;
        padding: 15px 45px;
        border-radius: 6px;
        cursor: pointer;
      }
    }

    .illustration {
      position: absolute;
      height: 100%;
      top: 0px;
      right: 0px;

      width: 870px;
    }
  }
}
</style>
